'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _throttle2 = require('lodash/throttle');

var _throttle3 = _interopRequireDefault(_throttle2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('cb.magazine.scrollToggler', []);

_module.directive('scrollTogglerV1', scrollTogglerV1);

exports.default = _module;


function scrollTogglerV1() {
    return {
        restrict: 'A',
        scope: true,
        bindToController: {
            scrollTogglerOffset: '@scrollTogglerOffset',
            scrollTogglerOnElement: '@scrollTogglerOnElement',
            scrollTogglerToggle: '@scrollTogglerToggle'
        },
        controller: ['$q', '$log', '$window', '$scope', '$element', function controller($q, $log, $window, $scope, $element) {
            var vm = this;

            var offsetFromElement = vm.scrollTogglerOnElement !== undefined ? true : false;

            // You can add extra parameters to this object if you want to add animations and so
            var classes = {
                default: 'scroll-toggler',
                hidden: 'scroll-toggler--hidden',
                visible: 'scroll-toggler--visible'
            };
            var window = $window;
            var userScrolled = false;
            // Should the element toggle or just open on scroll?
            var toggle = vm.scrollTogglerToggle !== undefined ? true : false;

            // Functionality

            var toggleRespectiveToWindow = function toggleRespectiveToWindow(windowScroll, offset) {
                return windowScroll > offset ? [classes.default, classes.visible] : toggle ? [classes.default, classes.hidden] : vm.classList;
            };

            var toggleRespectiveToElement = function toggleRespectiveToElement(windowScroll, elmOffsetTop, offset, windowHeight) {
                return windowScroll + offset > elmOffsetTop - windowHeight ? [classes.default, classes.visible] : toggle ? [classes.default, classes.hidden] : vm.classList;
            };

            var eventHandler = function eventHandler(scrollTop) {
                var scrollTogglerOffset = vm.scrollTogglerOffset ? parseInt(vm.scrollTogglerOffset) : 0;
                var elementOffsetTop = $element[0].offsetTop;
                var classArray = offsetFromElement ? toggleRespectiveToElement(scrollTop, elementOffsetTop, scrollTogglerOffset, window.innerHeight) : toggleRespectiveToWindow(scrollTop, scrollTogglerOffset);

                (0, _keys2.default)(classes).forEach(function (key) {
                    _angular2.default.element($element).removeClass(classes[key]);
                });

                classArray.forEach(function (className) {
                    _angular2.default.element($element).addClass(className);
                });
            };

            /** Listen to scroll events */
            _angular2.default.element(window).bind('scroll', (0, _throttle3.default)(eventListenerCallback, 100));

            function eventListenerCallback() {
                var lastScrollTop = window.scrollY !== undefined ? window.scrollY : window.pageYOffset;
                eventHandler(lastScrollTop);
            }
        }],
        controllerAs: 'scrolltoggler'
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/magazine/scrollToggler/scrollToggler.directive.js
// module id = 844
// module chunks = 0